import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import 'styles/components/main/Content.scss';
import AOS from 'aos';
import "aos/dist/aos.css";
import { useNavigate } from 'react-router-dom';

const Content = () => {
    const menuItems = [
        { id: 1, name: '국방정보화', link: '/business?tab=informatization-of-nd' },
        { id: 2, name: '전자전', link: '/business?tab=electronic-warfare' },
        { id: 3, name: '시스템통합', link: '/business?tab=system-integration' },
        { id: 4, name: '연구개발', link: '/research?tab=core-technology' },
    ];

    useEffect(() => {
        AOS.init({
            duration: 700
        });
    });

    const navigate = useNavigate();

    return (
        <section className='Content'>
            <div className='Area-wrapper'>
                <div className='LeftArea'>
                    <p className='leftArea-text1'>어질인소프트는</p>
                    <div className='leftArea-text2'>
                        <p>축적된 노하우와 <br className='lineBreak m' />차세대 IT <br className='lineBreak' />기술을 바탕으로 </p>
                        <p className='fc_grey'>고객의 비즈니스 <br className='lineBreak' />성공을 지원합니다</p>
                    </div>
                </div>
                <div className='RightArea'>
                    <div className='rightArea-title' data-aos="fade-right">Business<span className='dot'>.</span></div>
                    <div className='rightArea-menu-items'>
                        {menuItems.map(menu => <div className='rightArea-menu-item' data-aos='fade-up' key={menu.id}>
                            <div className='rightArea-menu' onClick={() => navigate(`${menu.link}`)}>
                                <div className='rightArea-menu-id'>0{menu.id}</div>
                                <div className='rightArea-menu-name'>{menu.name}</div>
                            </div>
                            <div className='arrowRightBtn'>
                                <FontAwesomeIcon icon={faArrowRight} size='2x' />
                            </div>
                        </div>)}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default React.memo(Content);